// extracted by mini-css-extract-plugin
export var dropdown = "_sh-0";
export var imageWrapper = "_sh-3";
export var itemNameContainer = "_sh-1";
export var productImage = "_sh-2";
export var spinnerWrapper = "_sh-4";